import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    addButton: {
        "&.MuiButtonBase-root": {
            background: theme.palette.info.light,
            color: "white",
            height: "36px",
            fontFamily: "Open Sans",
        },
    },
    title: {
        fontFamily: "Open Sans",
        fontSize: "32px",
        fontWeight: "600",
    },
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    contentWrapper: {
        margin: "0 auto",
        marginTop: 66,
    },
    step: {
        "& .Mui-active": {
            color: `${theme.palette.info.light} !important`,
            "& text": {
                fill: "white !important",
            },
        },
        "& .Mui-completed": {
            color: `${theme.palette.primary.dark} !important`,
            "& text": {
                fill: "white !important",
            },
        },
    },
    tableRow: {
        "&:hover": {
            cursor: "pointer",
        },
    },
}));
